/* eslint-disable react/no-array-index-key */
import { Spacing16, Spacing8 } from 'autogen/design-tokens/tokens';
import styled from 'styled-components';
import type { HTMLAttributes } from 'react';
import VariantsSection from 'components/product/Variants/VariantSection/VariantsSection';
import { useTranslation } from 'react-i18next';
import type { VariantsProps } from './shared/types';
import FindationButton from 'components/Findation/FindationButton';
import RevieveVirtualTryOnButton from 'components/product/RevieveVirtualTryOn/RevieveVirtualTryOnButton';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
`;

const DigitalToolsContainer = styled.div`
    display: flex;
    gap: ${Spacing16};
`;

// #endregion Styles

export default function Variants({
    variants,
    productId,
    externalProductId,
    name,
    isModifaceEnabled,
    makeupInfo,
    revieveVirtualTryOn,
    ...restProps
}: VariantsProps & HTMLAttributes<HTMLDivElement>) {
    const hasVariants = !!variants && !!variants.sections[0]?.variants[0];
    const hasMultipleVariantSections = !!variants && variants.sections.length > 1;

    if (!hasVariants && !isModifaceEnabled) return null;

    return (
        <Wrapper {...restProps}>
            {variants?.sections.map((section, index) => {
                return (
                    <VariantsSection
                        variantsSection={section}
                        hasMultipleVariantSections={hasMultipleVariantSections}
                        key={index}
                    />
                );
            })}
            <DigitalToolsContainer>
                {revieveVirtualTryOn.config && (
                    <RevieveVirtualTryOnButton config={revieveVirtualTryOn} variants={variants} />
                )}
                {makeupInfo.isFindation && <FindationButton productId={externalProductId} productName={name} />}
            </DigitalToolsContainer>
        </Wrapper>
    );
}
